import React from "react";
import axios from 'axios';

function SignInForm({ onSwitchToForgotPassword }) {

    const [state, setState] = React.useState({
        email: "",
        password: ""
    });

    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    const handleChange = evt => {
        const value = evt.target.value;
        setError(null);
        setState({
            ...state,
            [evt.target.name]: value
        });
    };

    const handleOnSubmit = async (evt) => {
        evt.preventDefault();
        const { email, password } = state;
        setError(null);
        setLoading(true);

        try {
            const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            const response = await axios.post(
                '/login',
                {
                    user: {
                        email: email,
                        password: password
                    }
                },
                {
                    headers: {
                        'X-CSRF-Token': csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data.status && response.data.status.code === 200) {
                // Use server-provided redirect URL (set when Devise redirected from a protected page),
                // fallback to localStorage (set when user clicked a login link), then root
                const serverRedirect = response.data.redirect_to;
                const localRedirect = localStorage.getItem('redirectAfterLogin');
                const redirectTo = (serverRedirect && serverRedirect !== '/') ? serverRedirect : (localRedirect || serverRedirect || '/');
                localStorage.removeItem('redirectAfterLogin');
                window.location.href = redirectTo;
            }
        } catch (err) {
            const msg = err.response?.data?.error
                || err.response?.data?.status?.message
                || "Email ou mot de passe incorrect. Veuillez réessayer.";
            setError(msg);
        } finally {
            setLoading(false);
        }

        setState({
            email: "",
            password: ""
        });
    };

    return (
        <div className="form-container sign-in-container">
            <form className="auth-form" onSubmit={handleOnSubmit}>
                <h1 className="auth-title">Se connecter</h1>
                {error && (
                    <div style={{
                        color: '#7c2837',
                        background: 'rgba(124,40,55,0.08)',
                        border: '1px solid rgba(124,40,55,0.30)',
                        borderRadius: '8px',
                        padding: '10px 14px',
                        marginBottom: '12px',
                        fontSize: '13px',
                        fontWeight: '600',
                        textAlign: 'center',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}>
                        ❌ {error}
                    </div>
                )}
                <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={state.email}
                    className="auth-input"
                    onChange={handleChange}
                />
                <input
                    type="password"
                    name="password"
                    placeholder="Mot de passe"
                    value={state.password}
                    onChange={handleChange}
                    className="auth-input"
                />
                <a className="auth-link" href="#" onClick={(e) => { e.preventDefault(); onSwitchToForgotPassword && onSwitchToForgotPassword(); }}>Mot de passe oublié ?</a>
                <button type="submit" className="auth-button" disabled={loading}>
                    {loading ? 'Connexion…' : 'Se connecter'}
                </button>
            </form>
        </div>
    );
}

export default SignInForm;

